import script from "./ValidateSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateSkills.vue?vue&type=script&setup=true&lang=js"

import "./ValidateSkills.vue?vue&type=style&index=0&id=cf8f790a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf8f790a"]])

export default __exports__